export default "__VITE_ASSET__B5VV5y4W__"